module.exports = __webpack_public_path__ + "static/media/phaneroptera_falcata.13dbd12b.jpg";